import { render } from "./OtpStep.vue?vue&type=template&id=58da44b4&scoped=true"
import script from "./OtpStep.vue?vue&type=script&lang=js"
export * from "./OtpStep.vue?vue&type=script&lang=js"

import "./OtpStep.vue?vue&type=style&index=0&id=58da44b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58da44b4"]])

export default __exports__